// relative
import { apiSliceV2 } from '../../apiSlice';

export const energyInitiativesApiSlice = apiSliceV2.injectEndpoints({
  tagTypes: ['EnergyInitiative'],
  endpoints: (builder) => ({
    getEnergyInitiativesById: builder.query({
      query: ({ energyInitiativeId }) => ({
        url: `/EnergyInitiatives/${energyInitiativeId}`,
      }),
      providesTags: ['EnergyInitiative'],
    }),
    postEnergyInitiative: builder.mutation({
      query: ({ energyGroupId, energyInitiative }) => ({
        url: `/EnergyGroups/${energyGroupId}/Initiative`,
        method: 'POST',
        body: energyInitiative,
      }),
      invalidatesTags: ['EnergyInitiative', 'EnergyGroup'],
    }),
    putEnergyInitiative: builder.mutation({
      query: ({ energyInitiativeId, updates }) => ({
        url: `/EnergyInitiatives/${energyInitiativeId}`,
        method: 'PUT',
        body: updates,
      }),
      invalidatesTags: ['EnergyInitiative', 'EnergyGroup'],
    }),
    deleteEnergyInitiative: builder.mutation({
      query: ({ energyInitiativeId }) => ({
        url: `/EnergyInitiatives/${energyInitiativeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EnergyInitiative', 'EnergyGroup'],
    }),
  }),
});

export const {
  useGetEnergyInitiativesByIdQuery,
  useLazyGetEnergyInitiativesByIdQuery,
  usePostEnergyInitiativeMutation,
  usePutEnergyInitiativeMutation,
  useDeleteEnergyInitiativeMutation,
} = energyInitiativesApiSlice;
